import { observer } from "mobx-react-lite";
import { useAppStores } from "./app-context";

export const ConnectivityStatus = observer(function ConnectivityStatus() {
  const { locale, status } = useAppStores();

  return (
    <span className="connectivity" role="status">
      <span aria-hidden="true" className={status.online ? "dot online" : "dot"} />
      {locale.text(status.online ? "connectivityOnline" : "connectivityOffline")}
    </span>
  );
});
